import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { FAQ_ITEMS } from "@/lib/citizen";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <div className="bg-white border border-zinc-200 rounded-sm divide-y divide-zinc-100" data-testid="faq-section">
      {FAQ_ITEMS.map((it, i) => {
        const isOpen = open === i;
        return (
          <div key={it.q}>
            <button
              data-testid={`faq-toggle-${i}`}
              onClick={() => setOpen(isOpen ? -1 : i)}
              className="w-full flex items-center justify-between gap-4 px-6 py-4 text-left hover:bg-zinc-50 transition"
            >
              <span className="font-medium text-zinc-900 text-sm sm:text-base">{it.q}</span>
              <ChevronDown className={`w-4 h-4 text-zinc-500 transition-transform flex-shrink-0 ${isOpen ? "rotate-180" : ""}`} />
            </button>
            {isOpen && (
              <div className="px-6 pb-5 text-sm text-zinc-600 leading-relaxed animate-fade-in-up">
                {it.a}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
